import { BaseOption } from "entities/common";

export const COMPANY_COUNTRY = "United Arab Emirates";

export const EMIRATES = ["Abu Dhabi", "Ajman", "Dubai", "Fujairah", "Ras Al Khaimah", "Sharjah", "Umm Al Quwain"];

export const EMIRATE_OPTIONS: BaseOption[] = EMIRATES.map((name) => ({ value: name, label: name }));
